import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { ValidationCallback } from "validation/validate";

export interface Output {
	destinationAmount: number | undefined;
}

const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ flag, checkField }
) => {
	checkField("destinationAmount", {
		type: "number",
		isRequired: false
	});
};

type GetCurrencyConversionParams = {
	sourceCurrency: string;
	sourceAmount: number;
	destinationCurrency: string;
};

export const getCurrencyConversion = makeFetchData<
	GetCurrencyConversionParams,
	Output
>(
	"currencyConversion",
	flagValidationErrors,
	({ sourceAmount, ...rest }) => {
		return {
			...rest,
			sourceAmount: sourceAmount + ""
		};
	},
	undefined,
	{ cacheInMemory: true }
);
